"use client";

import { useRouter } from "@/i18n/navigation";
import { authClient } from "@/lib/auth/client";
import { useTranslations } from "next-intl";
import { toast } from "sonner";

export function useSignOut() {
    const router = useRouter();
    const t = useTranslations("nav");

    const signOut = async () => {
        try {
            const { error } = await authClient.signOut();

            if (error) {
                toast.error(t("signOutFailedTitle"), {
                    description: error.message ?? t("signOutRetry"),
                });
                return;
            }

            localStorage.removeItem("use-store");
            localStorage.removeItem("use-store_ts");
            toast.success(t("signOutSuccessTitle"), {
                description: t("signOutSuccessDesc"),
            });
            router.replace("/login");
            router.refresh();
        } catch {
            toast.error(t("signOutFailedTitle"), {
                description: t("signOutRetry"),
            });
        }
    };

    return { signOut };
}
